import React from 'react'
import Box from '@mui/material/Box'
import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'

import { FadBox } from '../../utils/fade-box/fadeBox.js'

import {
    engagements,
    kids,
    weddings
} from '../../utils/assets.js'

const Gallery = () => {
    let category = window.location.pathname.split('/')[1]
    const data = category === "engagements"
        ? engagements
        : category === "kids"
            ? kids
            : category === "weddings"
                ? weddings
                : null

    return (
        <Box
            width={'100%'}
            data-aos="fade-up">
            <ImageList
                variant="masonry"
                cols={2}
                gap={2}
                // Promote the list into its own layer in Chrome. This costs memory, but helps keeping high FPS.
                transform='translateZ(0)'>
                {data && data.map((item) => (
                    <ImageListItem key={item}>
                        <FadBox
                            src={item}
                            alt={item}
                        />
                    </ImageListItem>
                ))}
            </ImageList>
        </Box>
    )
}

export default Gallery